import React from 'react'

function Footer() {
  return (
    <div className='footer'>
            <img src="../img/zuri.svg" alt="zuri-image" />
            <p>HNG Internship 9 Frontend Task</p>
            <img src="../img/I4G.jpg" alt="I4G-image" />
    </div>
  )
}

export default Footer